import Backbone from 'backbone';

export default Backbone.Model.extend({
    defaults: {
        id              : 0,
        account_id      : 0,
        name            : '',
        content         : '',
        access_type     : '',
        created_at      : 0,
        created_by      : 0,
        updated_at      : 0,
        updated_by      : 0
    }
});
